import script from "./KYCStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./KYCStatus.vue?vue&type=script&setup=true&lang=js"

import "./KYCStatus.vue?vue&type=style&index=0&id=2ae43b72&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aparl\\Source\\Incodi\\gdm-self-service\\selfservice.dynamicmarkets.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ae43b72"]])

export default __exports__